import { useState, useRef } from "react";
import { Props_SnippetContentCard } from "./ContentCard.props";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import SnippetLink from "../Shared/Link/Link";

const SnippetContentCard = (props: Props_SnippetContentCard) => {
    const { snippet, heading, content, link } = props;

    const snippetIDRef = useRef<string>(
        Math.random().toString(36).substring(2, 10)
    );
    const snippetID = snippetIDRef.current;
    
    const classHeadingVisibility: string = heading.visibility.value
        ? `snippet-content-card__heading--${heading.visibility.value}`
        : "";
    
    const classSnippetStyle = snippet.style?.value 
        ? `snippet-content-card--${snippet.style.value}` 
        : "";
    
    const classBackground = snippet.background?.value 
        ? `snippet-content-card--bg-${snippet.background.value}` 
        : "";

    return (
        <section className={`snippet-content-card ${classSnippetStyle} ${classBackground}`}>
            <div className="snippet-content-card__container">
                <div className="snippet-content-card__content">
                    {heading?.content?.value && (
                        <h2
                            id={`snippet-content-card-${snippetID}`}
                            className={`snippet-content-card__heading ${classHeadingVisibility}`}
                        >
                            {heading.content.value}
                        </h2>
                    )}
                    
                    {content?.content?.value && (
                        <div className="snippet-content-card__text">
                            {CompileMarkdown(content.content.value)}
                        </div>
                    )}
                    
                    {link?.linkText?.value && link?.linkHref?.value && (
                            <SnippetLink
                                linkStyles={link.linkStyle?.value}
                                className="snippet-content-card__link"
                                url={link.linkHref.value}
                                openInNewTab={!!link.linkTarget?.value}
                                rel={link.linkTarget?.value ? "noopener noreferrer" : undefined}
                                aria-label={`${link.linkText.value} - ${heading?.content?.value || 'this card'}`}
                            >
                                {link.linkText.value}
                            </SnippetLink>
                    )}
                </div>
            </div>
        </section>
    );
};

export default SnippetContentCard;
